export const playlist = {
  queue: 0, // Current track in array index []
  tracks: [
    {
      title: "Belt Driven Tragedy",
      album: "The Factory Bloc",
      mp3src: require("../audio/30-second/the-factory-bloc/belt-driven-tragedy.mp3"),
      loaded: false,
      length: 30, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.0793,
        0.2398,
        0.4707,
        0.6121,
        0.7477,
        0.7203,
        0.8421,
        0.7983,
        0.7801,
        0.7299,
        0.7704,
        0.7438,
        0.7569,
        0.7767,
        0.9086,
        0.7934,
        0.8316,
        0.7560,
        0.6805,
        0.7125,
        0.7004,
        0.7199,
        0.7809,
        0.8076,
        0.8788,
        1.0000,
        0.6822,
        0.7630,
        0.9088,
        0.9026,
        0.8178,
        0.9207,
        0.9203,
        0.9231,
        0.7787,
        0.8875,
        0.8839,
        0.9051,
        0.8007,
        0.7686,
        0.7215,
        0.8991,
        0.7756,
        0.9018,
        0.8649,
        0.9438,
        0.8274,
        0.8283,
        0.6978,
        0.9306,
        0.7333,
        0.5895,
        0.3694,
        0.1174
      ]
    },
    {
      title: "The Factory Bloc",
      album: "The Factory Bloc",
      mp3src: require("../audio/30-second/the-factory-bloc/the-factory-bloc.mp3"),
      loaded: false,
      length: 30, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.0790,
        0.3117,
        0.4441,
        0.6313,
        0.6572,
        0.7589,
        0.8725,
        0.8088,
        0.6917,
        0.7544,
        0.6635,
        0.7032,
        0.7207,
        0.7585,
        0.8958,
        0.7610,
        0.6656,
        0.7886,
        0.7507,
        0.6312,
        0.6512,
        0.7479,
        0.9696,
        0.7548,
        0.7167,
        0.7697,
        0.7431,
        0.7445,
        0.7730,
        0.8321,
        0.9358,
        0.7699,
        0.8444,
        0.9555,
        0.8393,
        0.7976,
        0.8335,
        0.9341,
        0.8639,
        0.7748,
        0.8143,
        0.8974,
        0.7542,
        0.8197,
        0.9434,
        1.0000,
        0.9854,
        0.9189,
        0.8612,
        0.8980,
        0.7097,
        0.5377,
        0.3263,
        0.1070
      ]
    },
    {
      title: "Tentacle",
      album: "The Factory Bloc",
      mp3src: require("../audio/30-second/the-factory-bloc/tentacle.mp3"),
      loaded: false,
      length: 30, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.0910,
        0.3093,
        0.4594,
        0.5994,
        0.4688,
        0.5068,
        0.7581,
        0.7671,
        0.6378,
        0.7740,
        0.8245,
        0.7955,
        0.8400,
        0.7684,
        0.8380,
        0.5889,
        0.4673,
        0.5706,
        0.8172,
        0.7534,
        0.6828,
        0.8438,
        0.8627,
        0.8226,
        0.8171,
        0.7774,
        0.7009,
        0.6149,
        0.5353,
        0.5629,
        0.7827,
        0.7485,
        0.7384,
        0.7415,
        0.8254,
        0.8271,
        0.7815,
        0.8009,
        0.8962,
        0.6801,
        0.5519,
        0.8361,
        0.8332,
        0.8143,
        0.7915,
        0.9170,
        1.0000,
        0.8964,
        0.8058,
        0.8118,
        0.7194,
        0.3975,
        0.1928,
        0.0573
      ]
    },
    {
      title: "Abandon Launch",
      album: "The Factory Bloc",
      mp3src: require("../audio/30-second/the-factory-bloc/abandon-launch.mp3"),
      loaded: false,
      length: 30, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.0789,
        0.3266,
        0.4458,
        0.7413,
        0.8134,
        0.6848,
        0.7309,
        0.8378,
        0.7958,
        0.6288,
        0.6872,
        0.6901,
        0.6567,
        1.0000,
        0.7750,
        0.8384,
        0.7635,
        0.7386,
        0.8448,
        0.6894,
        0.8944,
        0.8853,
        0.9486,
        0.8486,
        0.7993,
        0.8979,
        0.8388,
        0.6843,
        0.8943,
        0.9703,
        0.9098,
        0.8726,
        0.9195,
        0.7350,
        0.9010,
        0.9199,
        0.9173,
        0.8776,
        0.7204,
        0.8876,
        0.8696,
        0.7024,
        0.8774,
        0.9066,
        0.8915,
        0.7727,
        0.8707,
        0.7659,
        0.7546,
        0.9806,
        0.8742,
        0.5784,
        0.3574,
        0.1160
      ]
    }
  ]
};
